/*
function to parse the response from the request to VAO service
*/

/* function to split returned departures by directions, public transport types and hours.
 * param: departureData -> returned departures from requests to VAO services
 * output -->
 * {
 *      "hourSequence": [5, 6, 7, 8, 9,...,23, 0, 1, 2, 3, 4]
 *      "numberOfDepartures": {H:{"7":[0,0,0...], "6":[0,0,0...], ...},R:{"7":[0,0,0...],...}},
 *      "directionInfo": {H:{"7":[["itzling", "science city"...],[],[]...]}, R:{...}}
 * }
 * */
export default function splitDirectionAndHour(departureData){
    let ptTypeArr = {H:[], R:[]}
    const numberOfDepartures = {H:{}, R:{}}
    const directionInfo = {H:{}, R:{}}

    function getDepartureHour(time){
        return time.split(":")[0]
    }

    // get hourSequence of the bus service from the first bus service of the day
    // if the first bus service starts at 5, then the sequence is [5,6, 7, ..., 23, 0, 1, ...]
    function generateHourSequence(startHour) {
        const hourArray = [];
        let hour = parseInt(startHour);
        for (let i = 0; i < 24; i++) {
            hourArray.push(hour);
            if (hour < 23) {
                hour += 1;
            } else {
                hour = 0;
            }
        }
        return hourArray;
    }

    // formate direction flag
    function formatDirectionFlag(oldDirectionFlag){
        switch (oldDirectionFlag) {
            case "1":
            case "0":
                return "H";
            case "2":
                return "R"
            default:
                return oldDirectionFlag || "H";  // If oldDirectionFlag is undefined, null, or any falsy value, it defaults to "H".
        }
    }

    // determine starting hour (the first service of the day) and hour sequence
    const startHour = getDepartureHour(departureData[0]["time"]);
    const hourSeq = generateHourSequence(startHour);

    departureData.forEach((e) => {
        // check if there is directionFlag, if not, assign "H"
        const direction = formatDirectionFlag(e["directionFlag"]);


        // Error checking for invalid direction
        if (direction !== "H" && direction !=="R"){console.error("Invalid direction:", direction, e)}

        const ptType = e["Product"][0]["catCode"];
        const directionName = e["direction"];
        const time = e["time"];
        const hr = getDepartureHour(time);
        const hrIndex = hourSeq.indexOf(parseInt(hr)); // get the index of the departure hour

        // if such pt type doesn't exist in the type array yet
        if (!ptTypeArr[direction].includes(ptType)) {
            ptTypeArr[direction].push(ptType);
            // create zero/empty array filled arrays with length 24 for later
            numberOfDepartures[direction][ptType] = new Array(24).fill(0);
            directionInfo[direction][ptType] = Array.from(Array(24), () => []);
        }

        // update number of depatures
        numberOfDepartures[direction][ptType][hrIndex] += 1;

        // update direction information if not already added
        if (!directionInfo[direction][ptType][hrIndex].includes(directionName)) {
            directionInfo[direction][ptType][hrIndex].push(directionName);
        }
    });
    return { "hourSequence": hourSeq, "numberOfDepartures": numberOfDepartures, "directionInfo": directionInfo };
}
